module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.finished || _vm.loadingMore) ? _c('div', {
    staticClass: "ibox-content text-center"
  }, [(_vm.loadingMore) ? [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-2x fa-fw text-muted"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])] : _vm._e(), _vm._v(" "), (_vm.finished) ? [_vm._t("finished", [_vm._v("No More Results")])] : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-61a4fe07"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/LazyLoading.vue
// module id = 1021
// module chunks = 0